export const addressMap = {
  "0x0073d46db23fa08221b76ba7f497c04b72bd3529": "Willdabeast00",
  "0x1748657e354e30247fcdbb403e69e9dc3d9a7735": "Dafeng",
  "0xdfc107cc5e5f4064c717966f8d54311afe97142a": "adadcarry",
  "0xcd6b6d99b7751ff30b68fa1365488eb73fa7cefa": "kingnftvn",
  "0x524a163e38e69fc120415875200922109a62ca05": "CrabInc",
  "0x4b38ef4dbd564019a2fc51b6b280b736c62e0ae8": "niuning95",
  "0x2553e6471c779ab3278ffa21300e12725ab5ab2f": "CypressPond",
  "0xdc93fef5564989471d0ac9b047a95a5c8491b002": "0xbtroot",
  "0x704de6418d5cac37bc5607290fbcbcb7a3b274b7": "Alexfawcett",
  "0xbcd8671f0799646573f73e9aafb875219a8721a5": "xiuc",
  "0xaa4efd397ed95854a1aabbd0d3c0f9a22583aca7": "0xbitsun",
  "0x41a24d16715e5c0db012334595017abea537d33e": "nickewansmith.eth",
  "0x12fe20de6b441f18ba9a3c9a7a78c9bd16723e8d": "188btc.eth",
  "0x597f0f68aa64a2216d395d4829d4657a2f3fa745": "ariswap",
  "0x0c7cdee7f65f2be9d3d241a8caf43fd2773e263b": "W_O_W",
  "0xc17ec9d8e72ab957ac73596846ac87b8c7f80be2": "Block_Invest1",
  "0x9bf68b9a9b377f3ba0c40c1c5d8322e3ed8ee590": "Tomydigitaltrader",
  "0x2808edd543813fcf418de85bb42eedf3b39ba72c": "DCal",
  "0x2c02078935fe5b407583209d7bc22df60fbdf958": "blocktv.eth",
  "0xebb8f70d40d62864eab334c66bb5b88ce558054f": "hogehoge.eth",
  "0x8b4e7ac91e8a6aac0c087f2bfa7c42cdcea32e96": "Yagami96",
  "0xc5e7c5032d203b69da4d8feb7f3c3179fd9cb83b": "ShawnXP",
  "0xddf2b130c82d9fcdc5c7ca2e78f7fe2a5a0df6fc": "cyberwannabe",
  "0xb7f51ad220953d56908f8a0c50f64e3851f5c848": "diepca102.eth",
  "0xe12d52275eb64ff18680aa2b081fef8b736cd66d": "RobK",
  "0x3aef315b67c2e23aae9e9c1174d05371e2c9b144": "Jack_Giao",
  "0x9d6afd3dd7cbe2429764788c2ef3a607d57943d6": "cryptol.eth",
  "0xcc3d7f9fe6946979215a901bba385a88fdabbbf4": "dvinataba.eth",
  "0xab769309ebceeda984e666ab727b36211ba02a8a": "DegenKingo",
  "0x0268aa1755b49fa115a81090b836f2b111a20163": "jimmy",
  "0xeeff517294d2aa759274703a1b1c5ac81f9a754b": "whitesocks.eth",
  "0xa9d90e75144658ee480fff3f291cb77cb6024ba9": "Leamax006",
  "0x3890c5c513d5858fd03d4a09f8a16e6d7ef9d1ba": "ateens",
  "0xd6803a63775e678a346d5c07cf101aa01dd88734": "linyx.eth",
  "0x179379101c711ac27e0cbb4809f5777ccb4d1a72": "Seth",
  "0x0d8c60eca6e23104203818c4cf953bec5be340dc": "bowie",
  "0x52d63a71944b229abc2507a0d6e6767d10c142e2": "jamalr.eth",
  "0x83121b33597ddba73cc73e343bfca26a0a897ff2": "stonky",
  "0x07e401244bbf165f775e382984a7cc2aa1211aa1": "kaushalC",
};

export const b = [
  "0xbcfe78a91b6968322ed1b08fbe3a081353487910",
  "0xda534b166b94e4eb80a12ba005469140402c76f7",
  "0xca5cf09f56491abc63a7bfbee8ff1e25d2edd88f",
  "0xcd6b6d99b7751ff30b68fa1365488eb73fa7cefa",
  "0xce557bb2eeb69162116e60472890503b9da8c5a6",
  "0x000000000000000000000000000000000000dead",
];
